import { Expose, Type } from 'class-transformer';
import { Model } from './model';
import { WhiteLabelUserComment } from './wl-user-comment-model';

export class WhiteLabelUsersCommentsWithRate extends Model {
  @Expose()
  @Type(() => WhiteLabelUserComment)
  latestReviews: WhiteLabelUserComment[];

  @Expose() overAllRate: number;
}
